import { isStringNullOrWhiteSpace } from 'owa-localize';
import { observer } from 'mobx-react-lite';
import { CloudIconWithOverlay, getIconCSSForAttachment } from 'owa-file-icon';

import * as React from 'react';

import styles from 'owa-file-icon/lib/components/AttachmentIconView.scss';
import classnamesBind from 'classnames/bind';
const classNames = classnamesBind.bind(styles);

export const enum IconSize {
    extraSmall,
    small,
}

export interface AttachmentIconViewBaseProps {
    contentType: string;
    customizeStyle?: string;
    embeddedItemClass?: string;
    fileName: string;
    iconSize: IconSize;
    isBlocked: boolean;
    isCloudy?: boolean;
    isFolder: boolean;
    useCloudIcon: boolean;
}

const AttachmentIconViewBase = observer(function AttachmentIconViewBase(
    props: AttachmentIconViewBaseProps
) {
    const {
        contentType,
        customizeStyle,
        embeddedItemClass,
        fileName,
        iconSize,
        isBlocked,
        isCloudy,
        isFolder,
        useCloudIcon,
    } = props;

    if (useCloudIcon && isCloudy) {
        return (
            <CloudIconWithOverlay
                fileName={fileName}
                contentType={contentType}
                isBlocked={isBlocked}
                isFolder={isFolder}
                embeddedItemClass={null}
            />
        );
    }

    let iconCSS: string;
    const isIconExtraSmall: boolean = iconSize === IconSize.extraSmall;
    if (isIconExtraSmall) {
        iconCSS = getIconCSSForAttachment(
            fileName,
            contentType,
            isBlocked,
            isFolder,
            embeddedItemClass
        ).extraSmall;
    } else {
        iconCSS = getIconCSSForAttachment(
            fileName,
            contentType,
            isBlocked,
            isFolder,
            embeddedItemClass
        ).medium;
    }

    return (
        <div
            className={classNames(
                isIconExtraSmall ? styles.extraSmallIcon : styles.icon,
                isStringNullOrWhiteSpace(customizeStyle) ? styles.iconDefault : customizeStyle,
                iconCSS
            )}
        />
    );
});
export default AttachmentIconViewBase;
